import { db } from '@/firebase/init';
import { collectionGroup, orderBy, query, where } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';
import { InvitationFromStore } from '@/types/types';

function useUserOrganizationsInvitations(
  userId: string,
): InvitationFromStore<'organization'>[] {
  const invitationsQuery = useMemo(
    () =>
      query(
        collectionGroup(db, 'organization_invitations'),
        where('invitedUserId', '==', userId),
        orderBy('createdAt', 'desc'),
      ),
    [userId],
  );

  const invitations = useFirestoreCollection<InvitationFromStore<'organization'>>(
    ['organizationsInvitations', userId],
    invitationsQuery,
  );

  return invitations;
}

export { useUserOrganizationsInvitations };
